import axios from '@/axios.js'
const apiUrl = 'https://management.evolugy.com/v1/';

export default {
    addClinic ({ dispatch, rootState }, payload) {
        return new Promise((resolve, reject) => {
            var config = {
                method: 'post',
                url: apiUrl+'clinics',
                headers: { 
                        'Authorization': 'Bearer '+rootState.AuthToken
                },
                data: payload
            };
            axios(config)
            .then(function (response) {

                console.log(response.data);
                dispatch('fetchClinics');
                resolve(response);

            })
            .catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    },
    fetchClinics ({ commit, rootState }) {

        var config = {
            method: 'get',
            url: apiUrl+'clinics/?perPage=25&currentPage=1',
            headers: { 
                    'Authorization': 'Bearer '+rootState.AuthToken
                }
        };

        axios(config)
        .then(function (response) {

            var myClinics = response.data.data.clinics.filter(obj => {
                return obj.created_by_id == rootState.AppActiveUser.id;
              });
            console.log(response.data);
            commit('SET_CLINICS', myClinics);

        })
        .catch(function (error) {
            console.log(error);

        });

    },
    editClinic ({ commit }, payload) {

    }
}